/// <amd-module name="SuiteCommerce.PagePrinter.PDP"/>
define("SuiteCommerce.PagePrinter.PDP", ["require", "exports", "SuiteCommerce.PagePrinter.Item.Model", "SuiteCommerce.PagePrinter.PDP.View", "SuiteCommerce.PagePrinter.PDP.Configuration"], function (require, exports, Item_Model_1, PDP_View_1, PDP_Configuration_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            var pdp = container.getComponent('PDP');
            if (pdp) {
                var childViewObject = {
                    'SocialSharing.Flyout': {
                        'ProductPrinter.Link': {
                            childViewConstructor: function () {
                                var itemModel = new Item_Model_1.ItemModel(pdp.getItemInfo().item);
                                if (itemModel.isPrintButtonEnable() || (PDP_Configuration_1.PDPConfiguration.activeButtonPrint && !itemModel.isPrintButtonDisable())) {
                                    return new PDP_View_1.PDPView({
                                        model: itemModel,
                                    });
                                }
                                return false;
                            },
                        },
                    },
                };
                pdp.addChildViews(pdp.PDP_FULL_VIEW, childViewObject);
            }
        },
    };
});
